<template>
  <div
    class="breadcrumb-area bg-f position-relative z-1"
    :style="{ backgroundImage: `url(${bannerBackground})` }"
  >
    <div class="container-fluid style-two">
      <div class="row">
        <div class="col-md-8">
          <h2 class="section-title style-two fw-semibold ls-n2 text-white mb-20">
            {{ pageTitle }}
          </h2>
          <ul class="d-inline-flex flex-wrap align-items-center list-unstyled mb-0">
            <li class="position-relative">
              <router-link to="/">Home</router-link>
            </li>
            <li class="position-relative">
              <span>{{ pageTitle }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useSiteDefaultsStore } from '@/stores/siteDefaultsStore'
import brBgDefault from '@/assets/img/br-bg.jpg'
import circleTextBreadcrumb from '@/assets/img/circle-text-breadcrumb.svg'
import favIcon from '@/assets/img/icons/fav-icon.svg'

export default {
    name: 'PageBanner',
    props: {
        pageTitle: {
            type: String,
            default: 'Page'
        },
        backgroundImage: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            circleTextImage: circleTextBreadcrumb,
            favIconImage: favIcon,
            defaultBg: brBgDefault
        }
    },
    computed: {
        siteDefaultsStore() {
            return useSiteDefaultsStore()
        },
        bannerBackground() {
            // Priority: 1. Prop, 2. CMS generic banner, 3. Default
            if (this.backgroundImage) {
                return this.backgroundImage
            }
            const genericBanner = this.siteDefaultsStore.getGenericPageBanner()
            return genericBanner || this.defaultBg
        }
    }
}
</script>

